module.exports = function() {
  return new Worker(__webpack_public_path__ + "8e8dbd582dcac1a2fa77.worker.js");
};